
const Header = () => {
  return (
    <div className='absolute w-full bg-gradient-to-b from-[#060730]  p-6 z-10'>
        <img className="" src="https://cdn.cookielaw.org/logos/1b21e05d-c206-4e0b-970e-2d73a23e42e8/da9290d2-0377-4d05-aff7-3a76fd6151f9/58e3f46e-bee9-4f9a-bc3d-88ef69db0670/max-logo.png" alt="logo" />
    </div>
  )
}

export default Header
